<template>
  <el-popover
    popper-class="data-grid-image-preview-cell-popper"
    trigger="hover"
    placement="right">
    <div class="data-grid-image-preview-cell-cont">
      <div class="preview-info">
        <span class="title theme-text">预览</span>
        <el-tooltip content="查看源" placement="top">
          <a :href="imageLink" target="_blank">
            <i class="iconfont icon-source"></i>
          </a>
        </el-tooltip>
      </div>
      <div class="preview-cont">
        <img :src="imageLink" alt="预览图片"/>
      </div>
    </div>
    <span slot="reference"
          class="data-grid-image-preview-cell">{{cellText || '图片预览'}}</span>
  </el-popover>
</template>

<script>
export default {
  name: 'DataGridImagePreviewCell',
  props: {
    cellValue: {
      type: String,
      required: true
    },
    cellParam: Object
  },
  computed: {
    cellText: function () {
      let cellParam = this.cellParam
      if (cellParam) {
        return cellParam.cellText
      }
    },
    imageLink: function () {
      return this.$contextPath(this.cellValue)
    }
  }
}
</script>

<style lang="scss">
  .data-grid-image-preview-cell {
    cursor: pointer;
  }
  .data-grid-image-preview-cell-popper {
    padding: 10px!important;
    .data-grid-image-preview-cell-cont {
      & > .preview-info {
        font-size: 12px;
        line-height: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        a {
          color: #606266;
          text-decoration: none;
          i {
            width: auto;
            font-size: 15px;
            vertical-align: -1px;
          }
          &:hover {
            color: #303133;
          }
        }
      }
      & > .preview-cont {
        margin-top: 8px;
        border-radius: 2px;
        overflow: hidden;
        img {
          display: block;
          margin: auto;
          max-width: 300px;
          max-height: 150px;
          min-width: 120px;
          min-height: 80px;
          background-color: #f0f2f5;
        }
      }
    }
  }
</style>
